import { Component, OnInit } from '@angular/core';
import { AssignCellComponent } from '@spartacus/organization/administration/components';
import { ICON_TYPE } from '../../model/user-profiles-icon.model';
import { IconComponent } from '@spartacus/storefront';

@Component({
    selector: 'app-efa-remove-assigned-cell',
    templateUrl: './efa-remove-assigned-cell.component.html',
    imports: [IconComponent]
})
export class EfaRemoveAssignedCellComponent<T> extends AssignCellComponent<T> implements OnInit {
  iconTypes = ICON_TYPE;
  ngOnInit(): void {
  }

}
